// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nurturer-platform {
  --bg: #F4F2EB;
  --surface: #FFFFFF;
  --surface-alt: #FAF8F2;
  --sidebar: #23C2C4;
  --sidebar-deep: #17A6A8;
  --primary: #0C8587;
  --primary-soft: #DEF3F3;
  --accent: #DD9F3C;
  --accent-soft: #F8ECD3;
  --ink: #1B241F;
  --ink-70: rgba(27, 36, 31, 0.70);
  --muted: #6C766F;
  --faint: #9AA29B;
  --border: rgba(28, 40, 33, 0.10);
  --on-dark: #FFFFFF;
  --on-dark-60: rgba(255, 255, 255, 0.74);
  --on-dark-40: rgba(255, 255, 255, 0.55);
  --sans: 'DM Sans', system-ui, -apple-system, sans-serif;
  --mono: 'JetBrains Mono', ui-monospace, monospace;
  --radius: 14px;
  --radius-sm: 10px;
  --shadow: 0 1px 2px rgba(20, 30, 24, 0.04), 0 8px 24px -16px rgba(20, 30, 24, 0.18);

  font-family: var(--sans);
  color: var(--ink);
  background: var(--bg);
  min-height: 100vh;
  width: 100%;
}

.nurturer-platform *,
.nurturer-platform *::before,
.nurturer-platform *::after {
  box-sizing: border-box;
}

.nurturer-platform .platform-shell {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.nurturer-platform .platform-sidebar {
  width: 248px;
  flex-shrink: 0;
  background: var(--sidebar);
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 16px 16px;
}

.nurturer-platform .platform-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 10px 24px;
}

.nurturer-platform .platform-brand-name {
  font-weight: 700;
  font-size: 18px;
  color: var(--on-dark);
  letter-spacing: -0.3px;
}

.nurturer-platform .platform-brand-eyebrow {
  font-family: var(--mono);
  font-size: 10px;
  color: var(--on-dark-40);
  letter-spacing: 1px;
  text-transform: uppercase;
}

.nurturer-platform .platform-nav-label {
  font-family: var(--mono);
  font-size: 10px;
  color: var(--on-dark-40);
  letter-spacing: 1.4px;
  text-transform: uppercase;
  padding: 0 12px 8px;
}

.nurturer-platform .platform-nav {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.nurturer-platform .platform-nav-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--on-dark-60);
  font-family: var(--sans);
  font-weight: 500;
  font-size: 14.5px;
  cursor: pointer;
  position: relative;
  transition: background 0.15s, color 0.15s;
}

.nurturer-platform .platform-nav-item:hover {
  background: rgba(234, 241, 236, 0.05);
}

.nurturer-platform .platform-nav-item.active {
  background: rgba(234, 241, 236, 0.10);
  color: var(--on-dark);
  font-weight: 600;
}

.nurturer-platform .platform-nav-item.active::before {
  content: '';
  position: absolute;
  left: -16px;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 99px;
  background: var(--accent);
}

.nurturer-platform .platform-nav-badge {
  margin-left: auto;
  font-size: 11.5px;
  font-weight: 700;
  border-radius: 99px;
  padding: 1px 8px;
  min-width: 22px;
  text-align: center;
  background: rgba(234, 241, 236, 0.12);
  color: var(--on-dark-60);
}

.nurturer-platform .platform-nav-item.active .platform-nav-badge {
  background: var(--accent);
  color: #26210F;
}

.nurturer-platform .platform-sidebar-foot {
  margin-top: auto;
}

.nurturer-platform .platform-warmth {
  background: rgba(234, 241, 236, 0.06);
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 12px;
}

.nurturer-platform .platform-warmth-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 9px;
}

.nurturer-platform .platform-warmth-title {
  font-size: 12.5px;
  color: var(--on-dark);
  font-weight: 600;
}

.nurturer-platform .platform-warmth-value {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--accent);
}

.nurturer-platform .platform-warmth-bar {
  height: 6px;
  border-radius: 99px;
  background: rgba(234, 241, 236, 0.12);
  overflow: hidden;
}

.nurturer-platform .platform-warmth-fill {
  width: 0%;
  height: 100%;
  border-radius: 99px;
  background: linear-gradient(90deg, var(--accent), #E9C078);
  transition: width 0.3s ease;
}

.nurturer-platform .platform-warmth-caption {
  font-size: 11.5px;
  color: var(--on-dark-40);
  margin-top: 9px;
  line-height: 1.4;
}

.nurturer-platform .platform-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: var(--radius-sm);
}

.nurturer-platform .platform-user-meta {
  min-width: 0;
  flex: 1;
}

.nurturer-platform .platform-user-name {
  font-size: 13.5px;
  color: var(--on-dark);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nurturer-platform .platform-user-role {
  font-size: 11.5px;
  color: var(--on-dark-40);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nurturer-platform .platform-logout {
  border: none;
  background: transparent;
  color: var(--on-dark-40);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.nurturer-platform .platform-logout:hover {
  color: var(--on-dark);
  background: rgba(255, 255, 255, 0.08);
}

.nurturer-platform .platform-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
}

.nurturer-platform .platform-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 32px;
  border-bottom: 1px solid var(--border);
  background: rgba(244, 242, 235, 0.85);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 20;
}

.nurturer-platform .platform-topbar h1 {
  font-size: 21px;
  font-weight: 700;
  color: var(--ink);
  margin: 0;
  letter-spacing: -0.4px;
}

.nurturer-platform .platform-topbar-sub {
  font-size: 13.5px;
  color: var(--muted);
  margin-top: 2px;
}

.nurturer-platform .platform-topbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nurturer-platform .platform-search {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 8px 12px;
  width: 220px;
  color: var(--faint);
  font-size: 13.5px;
}

.nurturer-platform .platform-bell {
  width: 38px;
  height: 38px;
  border-radius: var(--radius-sm);
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--ink-70);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.nurturer-platform .platform-bell-dot {
  position: absolute;
  top: 9px;
  right: 10px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--accent);
  border: 1.5px solid var(--surface);
}

.nurturer-platform .platform-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  position: relative;
}

.nurturer-platform .platform-content.full-bleed {
  overflow: hidden;
}

.nurturer-platform .platform-content .platform-legacy-view {
  min-height: 100%;
  position: relative;
}

.nurturer-platform .platform-avatar {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: 600;
  letter-spacing: -0.2px;
}

.nurturer-platform .platform-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(28, 40, 33, 0.18) transparent;
}

.nurturer-platform .platform-scroll::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

.nurturer-platform .platform-scroll::-webkit-scrollbar-thumb {
  background: rgba(28, 40, 33, 0.16);
  border-radius: 99px;
  border: 2px solid transparent;
  background-clip: content-box;
}

/* ── Shared view primitives ── */
.nurturer-platform .platform-btn {
  cursor: pointer;
  border: none;
  font-family: var(--sans);
  transition: background 0.15s, color 0.15s, box-shadow 0.15s, transform 0.08s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}

.nurturer-platform .platform-btn:active {
  transform: translateY(0.5px);
}

.nurturer-platform .platform-btn--primary {
  background: var(--primary);
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
}

.nurturer-platform .platform-btn--primary:hover {
  background: #0A7173;
}

.nurturer-platform .platform-btn--accent {
  background: var(--accent);
  color: #26210F;
  border-radius: 12px;
  font-weight: 600;
}

.nurturer-platform .platform-btn--soft {
  background: var(--primary-soft);
  color: var(--primary);
  border-radius: 10px;
  font-weight: 600;
}

.nurturer-platform .platform-btn--ghost {
  background: transparent;
  color: var(--muted);
  border-radius: 10px;
  font-weight: 600;
}

.nurturer-platform .platform-btn--outline {
  background: var(--surface);
  border: 1px solid rgba(28, 40, 33, 0.16);
  color: var(--ink);
  border-radius: 10px;
  font-weight: 600;
}

.nurturer-platform .platform-btn--md {
  font-size: 14px;
  padding: 10px 16px;
}

.nurturer-platform .platform-btn--lg {
  font-size: 15px;
  padding: 13px 22px;
}

.nurturer-platform .platform-btn--sm {
  font-size: 13px;
  padding: 8px 12px;
}

.nurturer-platform .platform-btn--link {
  background: transparent;
  color: var(--primary);
  font-weight: 600;
  font-size: 13.5px;
  padding: 4px 8px;
}

.nurturer-platform .platform-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.nurturer-platform .platform-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 99px;
  line-height: 1.3;
}

.nurturer-platform .platform-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.nurturer-platform .platform-clip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nurturer-platform .platform-row {
  display: flex;
  align-items: center;
}

@keyframes platformFade {
  from { transform: translateY(8px); }
  to { transform: none; }
}

.nurturer-platform .platform-fade {
  animation: platformFade 0.4s cubic-bezier(0.2, 0.7, 0.3, 1);
}

@media (prefers-reduced-motion: reduce) {
  .nurturer-platform .platform-fade {
    animation: none;
  }
}

@keyframes platformPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}

.nurturer-platform .platform-pulse {
  animation: platformPulse 0.5s linear infinite;
}

/* ── Dashboard ── */
.nurturer-platform .dashboard-view {
  padding: 28px 32px 56px;
  max-width: 1240px;
  margin: 0 auto;
}

.nurturer-platform .dashboard-hero {
  padding: 28px 30px;
  margin-bottom: 22px;
  background: linear-gradient(120deg, var(--primary), #23C2C4);
  border: none;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.nurturer-platform .dashboard-hero-glow {
  position: absolute;
  right: -40px;
  top: -60px;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: rgba(221, 159, 60, 0.14);
}

.nurturer-platform .dashboard-hero-date {
  font-family: var(--mono);
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.nurturer-platform .dashboard-hero-title {
  font-family: 'Newsreader', Georgia, serif;
  font-weight: 400;
  font-size: 34px;
  margin: 0;
  letter-spacing: -0.5px;
}

.nurturer-platform .dashboard-hero-copy {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.82);
  margin-top: 8px;
  max-width: 440px;
  line-height: 1.5;
}

.nurturer-platform .dashboard-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 26px;
}

.nurturer-platform .dashboard-stat {
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nurturer-platform .dashboard-stat--clickable {
  border: none;
  cursor: pointer;
  text-align: left;
  width: 100%;
  font-family: var(--sans);
  transition: box-shadow 0.15s, transform 0.12s;
}

.nurturer-platform .dashboard-stat--clickable:hover {
  box-shadow: 0 24px 60px -28px rgba(20, 30, 24, 0.30), 0 2px 6px rgba(20, 30, 24, 0.05);
  transform: translateY(-2px);
}

.nurturer-platform .dashboard-stat-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nurturer-platform .dashboard-stat-icon--primary { background: var(--primary-soft); color: var(--primary); }
.nurturer-platform .dashboard-stat-icon--accent { background: var(--accent-soft); color: var(--accent); }
.nurturer-platform .dashboard-stat-icon--info { background: #E6EDF6; color: #3F6FB0; }
.nurturer-platform .dashboard-stat-icon--rose { background: #F6E6EA; color: #B5546B; }

.nurturer-platform .dashboard-stat-value {
  font-size: 38px;
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -1.5px;
  line-height: 1;
}

.nurturer-platform .dashboard-stat-label {
  font-size: 14px;
  color: var(--ink-70);
  font-weight: 600;
  margin-top: 7px;
}

.nurturer-platform .dashboard-stat-sub {
  font-size: 12.5px;
  color: var(--muted);
  margin-top: 2px;
}

.nurturer-platform .dashboard-stat-trend {
  gap: 4px;
  font-family: var(--mono);
  font-size: 11.5px;
  color: #2C8059;
  background: #E2F0E7;
  padding: 4px 8px;
  border-radius: 99px;
}

.nurturer-platform .dashboard-columns {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 20px;
}

.nurturer-platform .dashboard-panel {
  padding: 8px 16px 14px;
}

.nurturer-platform .dashboard-panel-head {
  justify-content: space-between;
  padding: 16px 8px 10px;
}

.nurturer-platform .dashboard-panel-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
  margin: 0;
}

.nurturer-platform .dashboard-touch-row,
.nurturer-platform .dashboard-contact-row {
  gap: 14px;
  padding: 14px 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
  font-family: var(--sans);
}

.nurturer-platform .dashboard-contact-row {
  gap: 12px;
  padding: 11px 8px;
}

.nurturer-platform .dashboard-touch-row:hover,
.nurturer-platform .dashboard-contact-row:hover {
  background: var(--surface-alt);
}

.nurturer-platform .dashboard-touch-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--primary-soft);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nurturer-platform .dashboard-empty {
  text-align: center;
  color: var(--muted);
  padding: 24px 8px;
  font-size: 14px;
}

/* ── Touches ── */
.nurturer-platform .touches-view {
  display: grid;
  grid-template-columns: minmax(300px, 360px) 1fr;
  height: 100%;
  min-height: 0;
}

.nurturer-platform .touches-list {
  border-right: 1px solid var(--border);
  overflow-y: auto;
  padding: 18px 16px;
}

.nurturer-platform .touches-search {
  gap: 8px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 11px;
  padding: 10px 13px;
  margin-bottom: 16px;
  color: var(--faint);
  font-size: 13.5px;
}

.nurturer-platform .touches-search input {
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  font-family: var(--sans);
  font-size: 13.5px;
  color: var(--ink);
}

.nurturer-platform .touches-list-head {
  justify-content: space-between;
  padding: 0 4px 10px;
}

.nurturer-platform .touches-list-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--ink-70);
  letter-spacing: 0.2px;
}

.nurturer-platform .touches-list-count {
  font-family: var(--mono);
  font-size: 11.5px;
  color: var(--faint);
}

.nurturer-platform .touches-list-item {
  width: 100%;
  text-align: left;
  display: block;
  padding: 14px;
  border-radius: 12px;
  background: transparent;
  border: 1px solid transparent;
  margin-bottom: 4px;
  cursor: pointer;
  transition: background 0.15s;
  font-family: var(--sans);
}

.nurturer-platform .touches-list-item:hover {
  background: rgba(255, 255, 255, 0.6);
}

.nurturer-platform .touches-list-item.active {
  background: var(--surface);
  border-color: var(--border);
  box-shadow: var(--shadow);
}

.nurturer-platform .touches-sparkle-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: var(--accent);
  border: 2px solid var(--bg);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nurturer-platform .touches-compose {
  overflow-y: auto;
  background: var(--surface-alt);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.nurturer-platform .touches-compose-head {
  justify-content: space-between;
  padding: 16px 28px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 5;
}

.nurturer-platform .touches-compose-body {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 28px 48px;
  flex: 1;
}

.nurturer-platform .touches-ai-banner {
  gap: 12px;
  background: linear-gradient(120deg, #FBF4E6, #F8ECD3);
  border: 1px solid rgba(221, 159, 60, 0.3);
  border-radius: 13px;
  padding: 13px 16px;
  margin-bottom: 18px;
}

.nurturer-platform .touches-ai-chip {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nurturer-platform .touches-subject-label {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--faint);
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 7px;
}

.nurturer-platform .touches-subject-input {
  width: 100%;
  font-size: 21px;
  font-weight: 700;
  color: var(--ink);
  border: none;
  background: transparent;
  outline: none;
  letter-spacing: -0.4px;
  margin-bottom: 20px;
  padding: 0;
  font-family: var(--sans);
}

.nurturer-platform .touches-email-card {
  padding: 26px 28px;
  transition: opacity 0.3s;
}

.nurturer-platform .touches-email-card.dimmed {
  opacity: 0.45;
}

.nurturer-platform .touches-edit-paragraph {
  margin-bottom: 16px;
  font-size: 14.5px;
  line-height: 1.7;
  min-height: 96px;
}

.nurturer-platform .touches-article {
  width: 100%;
  text-align: left;
  display: flex;
  gap: 13px;
  align-items: flex-start;
  padding: 13px 14px;
  border-radius: 11px;
  margin-bottom: 9px;
  cursor: pointer;
  transition: all 0.15s;
  font-family: var(--sans);
}

.nurturer-platform .touches-article.selected {
  background: var(--primary-soft);
  border: 1px solid rgba(31, 90, 69, 0.25);
}

.nurturer-platform .touches-article:not(.selected) {
  background: var(--surface-alt);
  border: 1px solid var(--border);
}

.nurturer-platform .touches-article-radio {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nurturer-platform .touches-article-radio.selected {
  border: 2px solid var(--primary);
  background: var(--primary);
}

.nurturer-platform .touches-article-radio:not(.selected) {
  border: 2px solid rgba(28, 40, 33, 0.16);
  background: transparent;
}

.nurturer-platform .touches-action-bar {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  justify-content: space-between;
  padding: 14px 28px;
  background: rgba(255, 255, 255, 0.92);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  border-top: 1px solid var(--border);
}

.nurturer-platform .touches-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--muted);
  font-size: 15px;
  padding: 32px;
  text-align: center;
}

.nurturer-platform .platform-content.full-bleed .platform-legacy-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* ── Form inputs & toggles ── */
.nurturer-platform .platform-input,
.nurturer-platform .platform-textarea,
.nurturer-platform .platform-select {
  width: 100%;
  font-family: var(--sans);
  font-size: 14px;
  color: var(--ink);
  background: var(--surface-alt);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 11px 13px;
  outline: none;
  transition: border 0.15s, box-shadow 0.15s;
}

.nurturer-platform .platform-input:focus,
.nurturer-platform .platform-textarea:focus,
.nurturer-platform .platform-select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-soft);
}

.nurturer-platform .platform-input::placeholder,
.nurturer-platform .platform-textarea::placeholder {
  color: var(--faint);
}

.nurturer-platform .platform-textarea {
  resize: vertical;
  line-height: 1.55;
  min-height: 46px;
}

.nurturer-platform .platform-field {
  margin-bottom: 0;
}

.nurturer-platform .platform-field--full {
  grid-column: 1 / -1;
}

.nurturer-platform .platform-field-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
  margin-bottom: 6px;
}

.nurturer-platform .platform-toggle {
  width: 40px;
  height: 23px;
  border-radius: 99px;
  padding: 2px;
  border: none;
  cursor: pointer;
  background: rgba(28, 40, 33, 0.16);
  transition: background 0.2s;
  display: flex;
  align-items: center;
}

.nurturer-platform .platform-toggle--on {
  background: var(--primary);
}

.nurturer-platform .platform-toggle-knob {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.nurturer-platform .platform-toggle--on .platform-toggle-knob {
  transform: translateX(17px);
}

.nurturer-platform .platform-chip-list {
  flex-wrap: wrap;
  gap: 7px;
  padding-bottom: 9px;
}

.nurturer-platform .platform-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 500;
  padding: 4px 6px 4px 11px;
  border-radius: 99px;
}

.nurturer-platform .platform-chip--primary {
  color: var(--primary);
  background: var(--primary-soft);
}

.nurturer-platform .platform-chip--accent {
  color: var(--accent);
  background: var(--accent-soft);
}

.nurturer-platform .platform-chip-remove {
  width: 16px;
  height: 16px;
  border-radius: 99px;
  border: none;
  background: rgba(0, 0, 0, 0.08);
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  padding: 0;
  color: inherit;
}

.nurturer-platform .platform-section-title {
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 700;
  color: var(--ink);
}

.nurturer-platform .platform-overlay {
  position: absolute;
  inset: 0;
  background: var(--bg);
  z-index: 30;
  display: flex;
  flex-direction: column;
}

.nurturer-platform .platform-overlay--form {
  z-index: 40;
}

.nurturer-platform .platform-overlay-bar {
  justify-content: space-between;
  padding: 16px 32px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}

.nurturer-platform .platform-overlay-body {
  overflow-y: auto;
  flex: 1;
  padding: 32px;
}

/* ── Contacts ── */
.nurturer-platform .contacts-view {
  position: relative;
  height: 100%;
}

.nurturer-platform .contacts-scroll {
  height: 100%;
  overflow-y: auto;
  padding: 24px 32px 48px;
  max-width: 1240px;
  margin: 0 auto;
}

.nurturer-platform .contacts-toolbar {
  justify-content: space-between;
  margin-bottom: 22px;
  gap: 14px;
  flex-wrap: wrap;
}

.nurturer-platform .contacts-search {
  gap: 8px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 11px;
  padding: 11px 14px;
  flex: 1;
  max-width: 420px;
  min-width: 200px;
}

.nurturer-platform .contacts-search input {
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  font-family: var(--sans);
  font-size: 14px;
  color: var(--ink);
}

.nurturer-platform .contacts-toolbar-actions {
  gap: 10px;
  flex-wrap: wrap;
}

.nurturer-platform .contacts-view-toggle {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 3px;
  gap: 0;
}

.nurturer-platform .contacts-view-btn {
  width: 32px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--faint);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nurturer-platform .contacts-view-btn.active {
  background: var(--primary-soft);
  color: var(--primary);
}

.nurturer-platform .contacts-count {
  gap: 10px;
  margin-bottom: 18px;
  font-size: 13.5px;
  color: var(--muted);
}

.nurturer-platform .contacts-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.nurturer-platform .contacts-card {
  padding: 18px;
  cursor: pointer;
  transition: box-shadow 0.15s, transform 0.12s;
  min-width: 0;
  width: 100%;
}

.nurturer-platform .contacts-card:hover {
  box-shadow: 0 24px 60px -28px rgba(20, 30, 24, 0.30), 0 2px 6px rgba(20, 30, 24, 0.05);
  transform: translateY(-2px);
}

.nurturer-platform .contacts-card-head {
  gap: 12px;
  margin-bottom: 14px;
}

.nurturer-platform .contacts-card-name {
  font-size: 15.5px;
  font-weight: 700;
  color: var(--ink);
}

.nurturer-platform .contacts-card-sub {
  font-size: 12.5px;
  color: var(--muted);
  margin-top: 1px;
}

.nurturer-platform .contacts-trigger-chip {
  font-size: 11.5px;
  color: var(--ink-70);
  background: var(--surface-alt);
  border: 1px solid var(--border);
  padding: 3px 9px;
  border-radius: 99px;
}

.nurturer-platform .contacts-card-foot {
  justify-content: space-between;
  padding-top: 13px;
  border-top: 1px solid var(--border);
  margin-top: 14px;
}

.nurturer-platform .contacts-list-card {
  overflow: hidden;
  padding: 0;
}

.nurturer-platform .contacts-list-row {
  gap: 14px;
  padding: 14px 18px;
  cursor: pointer;
  transition: background 0.15s;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
  font-family: var(--sans);
  border-bottom: 1px solid var(--border);
}

.nurturer-platform .contacts-list-row:last-child {
  border-bottom: none;
}

.nurturer-platform .contacts-list-row:hover {
  background: var(--surface-alt);
}

.nurturer-platform .contact-detail-identity {
  padding: 28px;
  margin-bottom: 20px;
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
}

.nurturer-platform .contact-detail-name {
  font-size: 28px;
  font-weight: 700;
  color: var(--ink);
  margin: 0;
  letter-spacing: -0.6px;
}

.nurturer-platform .contact-detail-columns {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}

.nurturer-platform .contact-detail-panel {
  padding: 22px;
}

.nurturer-platform .contact-followup-card {
  padding: 18px;
  background: var(--surface-alt);
  text-align: center;
  min-width: 170px;
}

.nurturer-platform .contact-notes-box {
  background: var(--surface-alt);
  border: 1px solid var(--border);
  border-radius: 11px;
  padding: 14px;
  font-size: 13px;
  line-height: 1.55;
  color: var(--ink-70);
  margin-top: 4px;
  width: 100%;
  min-height: 80px;
  resize: vertical;
  font-family: var(--sans);
}

.nurturer-platform .contact-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.nurturer-platform .contact-form-card {
  padding: 28px;
}

.nurturer-platform .contact-form-actions {
  justify-content: center;
  gap: 12px;
  margin-top: 28px;
  padding-top: 22px;
  border-top: 1px solid var(--border);
}

/* ── Cards ── */
.nurturer-platform .cards-view {
  height: 100%;
  overflow-y: auto;
  padding: 28px 32px 56px;
  max-width: 1240px;
  margin: 0 auto;
}

.nurturer-platform .cards-header {
  justify-content: space-between;
  margin-bottom: 26px;
  gap: 16px;
  flex-wrap: wrap;
}

.nurturer-platform .cards-header-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--accent-soft);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nurturer-platform .cards-groups {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  align-items: start;
}

.nurturer-platform .cards-group-head {
  gap: 9px;
  margin-bottom: 16px;
}

.nurturer-platform .cards-group-title {
  font-size: 15.5px;
  font-weight: 700;
  color: var(--ink);
  margin: 0;
}

.nurturer-platform .cards-group-count {
  font-family: var(--mono);
  font-size: 11.5px;
  color: var(--faint);
  background: var(--surface-alt);
  padding: 2px 9px;
  border-radius: 99px;
  border: 1px solid var(--border);
}

.nurturer-platform .cards-template-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.nurturer-platform .card-template-preview {
  position: relative;
  aspect-ratio: 3 / 4;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: var(--shadow);
}

.nurturer-platform .card-template-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nurturer-platform .card-template-default-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
}

.nurturer-platform .card-template-actions {
  justify-content: space-between;
  margin-top: 12px;
}

/* ── Newsletter ── */
.nurturer-platform .newsletter-view {
  display: grid;
  grid-template-columns: 340px 1fr;
  height: 100%;
  min-height: 0;
}

.nurturer-platform .newsletter-builder {
  border-right: 1px solid var(--border);
  overflow-y: auto;
  padding: 22px 20px;
}

.nurturer-platform .newsletter-builder .platform-field {
  margin-bottom: 16px;
}

.nurturer-platform .newsletter-builder .platform-field:first-of-type + .platform-field {
  margin-top: 4px;
}

.nurturer-platform .newsletter-preview-pane {
  overflow-y: auto;
  background: var(--surface-alt);
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 0;
}

.nurturer-platform .newsletter-preview-card {
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
}

.nurturer-platform .newsletter-preview-scroll {
  overflow: visible;
  max-height: none;
  margin-bottom: 4px;
  padding-right: 0;
}

.nurturer-platform .newsletter-preview-email {
  overflow: visible;
}

.nurturer-platform .newsletter-preview-hero-thumb {
  width: 92px;
  height: 72px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nurturer-platform .newsletter-preview-greeting {
  font-size: 19px;
  font-weight: 700;
  color: var(--ink);
  margin: 20px 0 14px;
  text-align: left;
}

.nurturer-platform .newsletter-preview-subheading {
  font-size: 14px;
  color: var(--muted);
  margin: 0 0 12px;
  text-align: left;
}

.nurturer-platform .newsletter-preview-images {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 8px;
}

.nurturer-platform .newsletter-preview-image-placeholder {
  flex: 1 1 160px;
  min-height: 120px;
  max-width: 240px;
  border-radius: 10px;
  background: var(--surface-2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nurturer-platform .newsletter-preview-rounded-content {
  padding: 36px 28px 32px;
  position: relative;
  z-index: 1;
  text-align: center;
}

.nurturer-platform .newsletter-preview-rounded-avatar {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: var(--surface-2);
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 32px -16px rgba(20, 30, 24, 0.25);
}

.nurturer-platform .newsletter-preview-rounded-headline {
  font-size: 26px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 20px;
  letter-spacing: -0.4px;
  position: relative;
  z-index: 1;
}

.nurturer-platform .newsletter-preview-header {
  background: linear-gradient(120deg, var(--primary), #23C2C4);
  padding: 32px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nurturer-platform .newsletter-preview-body {
  padding: 28px 30px;
  text-align: center;
}

.nurturer-platform .newsletter-template-picker {
  width: 100%;
  margin-top: 20px;
  padding-top: 4px;
}

.nurturer-platform .newsletter-preview-rounded {
  position: relative;
  background: #fff;
}

.nurturer-platform .newsletter-preview-rounded-accent {
  position: absolute;
  z-index: 0;
}

.nurturer-platform .newsletter-preview-rounded-accent--top {
  top: 260px;
  right: 0;
  width: 180px;
  height: 32px;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 25% 100%);
          clip-path: polygon(0 0, 100% 0, 100% 100%, 25% 100%);
}

.nurturer-platform .newsletter-preview-rounded-accent--bottom {
  bottom: 0;
  left: 0;
  width: 120px;
  height: 120px;
  -webkit-clip-path: polygon(0 100%, 100% 100%, 0 0);
          clip-path: polygon(0 100%, 100% 100%, 0 0);
}

.nurturer-platform .newsletter-swatch {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  cursor: pointer;
  border: none;
}

.nurturer-platform .newsletter-swatch.selected {
  box-shadow: 0 0 0 2px var(--surface), 0 0 0 4px currentColor;
}

.nurturer-platform .newsletter-recipient {
  gap: 11px;
  padding: 9px 6px;
  border-radius: 9px;
  cursor: pointer;
}

.nurturer-platform .newsletter-recipient:hover {
  background: rgba(255, 255, 255, 0.5);
}

.nurturer-platform .newsletter-checkbox {
  width: 19px;
  height: 19px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nurturer-platform .newsletter-checkbox.checked {
  border: 2px solid var(--primary);
  background: var(--primary);
}

.nurturer-platform .newsletter-checkbox:not(.checked) {
  border: 2px solid rgba(28, 40, 33, 0.16);
  background: transparent;
}

/* ── Settings ── */
.nurturer-platform .settings-view {
  height: 100%;
  overflow-y: auto;
  padding: 28px 32px 56px;
  max-width: 900px;
  margin: 0 auto;
}

.nurturer-platform .settings-tabs {
  gap: 4px;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--border);
  flex-wrap: wrap;
}

.nurturer-platform .settings-tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  color: var(--muted);
  font-weight: 600;
  font-size: 14px;
  padding: 10px 14px;
  cursor: pointer;
  font-family: var(--sans);
}

.nurturer-platform .settings-tab.active {
  color: var(--ink);
  border-bottom-color: var(--primary);
}

.nurturer-platform .settings-card {
  padding: 26px;
}

.nurturer-platform .settings-inline-error {
  color: #b5546b;
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 12px;
}

.nurturer-platform .settings-invite-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 12px 0 16px;
  align-items: center;
}

.nurturer-platform .settings-team-share {
  margin: 14px 0 18px;
  padding: 14px 0 18px;
  border-bottom: 1px solid var(--border);
}

.nurturer-platform .settings-team-share-label {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 4px;
}

.nurturer-platform .settings-team-share-copy {
  font-size: 12.5px;
  color: var(--muted);
  margin: 0 0 12px;
  line-height: 1.45;
}

.nurturer-platform .settings-invite-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.nurturer-platform .settings-invite-row .platform-input {
  flex: 1;
  min-width: 0;
}

.nurturer-platform .settings-invite-form .platform-input {
  min-width: 180px;
  flex: 1;
}

.nurturer-platform .settings-invite-link {
  font-size: 12.5px;
  color: var(--muted);
  margin: 0 0 16px;
  line-height: 1.5;
  word-break: break-all;
}

.nurturer-platform .settings-team-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid var(--border);
}

.nurturer-platform .settings-team-meta {
  min-width: 0;
  flex: 1;
}

.nurturer-platform .settings-team-name {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--ink);
}

.nurturer-platform .settings-team-you,
.nurturer-platform .settings-team-pending {
  font-weight: 500;
  color: var(--faint);
}

.nurturer-platform .settings-team-pending {
  color: #b6791a;
}

.nurturer-platform .settings-team-email {
  font-size: 11.5px;
  color: var(--muted);
}

.nurturer-platform .settings-team-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nurturer-platform .settings-role-select {
  width: auto;
  min-width: 110px;
  padding: 6px 10px;
  font-size: 12px;
}

.nurturer-platform .settings-remove-btn {
  border: none;
  background: transparent;
  color: #b5546b;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--sans);
}

.nurturer-platform .settings-role-badge {
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(28, 40, 33, 0.06);
  color: var(--muted);
}

.nurturer-platform .settings-role-badge.admin {
  background: var(--primary-soft);
  color: var(--primary);
}

.nurturer-platform .settings-products-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.nurturer-platform .settings-product-card {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0;
  min-height: 140px;
}

.nurturer-platform .settings-product-card .platform-btn {
  align-self: flex-start;
  margin-top: 20px;
  min-height: 34px;
  padding: 7px 14px;
  font-size: 13px;
  width: auto;
}

.nurturer-platform .subscription-view {
  padding: 0;
  max-width: none;
  margin: 0;
}

.nurturer-platform .subscription-current {
  padding: 24px 26px;
  margin-bottom: 22px;
  background: linear-gradient(120deg, var(--primary), #23c2c4);
  border: none;
  color: #fff;
}

.nurturer-platform .subscription-current-label {
  font-family: var(--mono);
  font-size: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 6px;
}

.nurturer-platform .subscription-current-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px;
}

.nurturer-platform .subscription-current-meta {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
}

.nurturer-platform .subscription-plans {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.nurturer-platform .subscription-plan {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: 100%;
}

.nurturer-platform .subscription-plan--featured {
  border-color: rgba(12, 133, 135, 0.35);
  box-shadow: 0 24px 60px -28px rgba(12, 133, 135, 0.25);
}

.nurturer-platform .subscription-plan-head {
  justify-content: space-between;
}

.nurturer-platform .subscription-plan-name {
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
  margin: 0;
}

.nurturer-platform .subscription-plan-price {
  font-size: 32px;
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -1px;
  margin: 0;
}

.nurturer-platform .subscription-plan-period {
  font-size: 14px;
  color: var(--muted);
  font-weight: 500;
}

.nurturer-platform .subscription-plan-note {
  font-size: 13px;
  color: var(--muted);
  margin: 6px 0 0;
  line-height: 1.4;
}

.nurturer-platform .subscription-feature-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

.nurturer-platform .subscription-feature {
  gap: 10px;
  font-size: 14px;
  color: var(--ink-70);
}

.nurturer-platform .subscription-feature-icon {
  color: var(--primary);
  flex-shrink: 0;
}

.nurturer-platform .subscription-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: auto;
}

.nurturer-platform .subscription-actions--row {
  flex-direction: row;
  gap: 18px;
  margin-top: 18px;
}

.nurturer-platform .subscription-actions--row > * {
  flex: 1;
  min-width: 0;
}

.nurturer-platform .subscription-actions .platform-btn {
  min-height: 50px;
  padding: 14px 20px;
  font-size: 15px;
}

.nurturer-platform .subscription-note {
  gap: 10px;
  padding: 14px 16px;
  border-radius: 12px;
  background: var(--accent-soft);
  color: #7a5a1e;
  font-size: 13.5px;
  margin-top: 18px;
}

.nurturer-platform .subscription-overage {
  margin-top: 18px;
  padding: 18px 20px;
  background: var(--surface-alt);
}

.nurturer-platform .subscription-overage-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 6px;
}

.nurturer-platform .subscription-overage-copy {
  font-size: 14px;
  color: var(--muted);
  margin: 0;
  line-height: 1.55;
}

.nurturer-platform .subscription-overage-copy strong {
  color: var(--ink);
  font-weight: 700;
}

.nurturer-platform .settings-profile-head {
  gap: 18px;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--border);
}

.nurturer-platform .settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.nurturer-platform .settings-row {
  justify-content: space-between;
  padding: 13px 0;
  border-bottom: 1px solid var(--border);
}

.nurturer-platform .settings-row:last-child {
  border-bottom: none;
}

@media (max-width: 1100px) {
  .nurturer-platform .dashboard-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .nurturer-platform .dashboard-columns {
    grid-template-columns: 1fr;
  }

  .nurturer-platform .contacts-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .nurturer-platform .contact-detail-columns {
    grid-template-columns: 1fr;
  }

  .nurturer-platform .cards-groups {
    grid-template-columns: 1fr;
  }

  .nurturer-platform .subscription-plans,
  .nurturer-platform .settings-products-grid {
    grid-template-columns: 1fr;
  }

  .nurturer-platform .subscription-actions--row {
    flex-direction: column;
  }
}

@media (max-width: 900px) {
  .nurturer-platform .platform-sidebar {
    width: 72px;
    padding: 16px 10px;
  }

  .nurturer-platform .platform-brand-text,
  .nurturer-platform .platform-nav-label,
  .nurturer-platform .platform-nav-item span:not(.platform-nav-badge),
  .nurturer-platform .platform-warmth,
  .nurturer-platform .platform-user-meta {
    display: none;
  }

  .nurturer-platform .platform-nav-item {
    justify-content: center;
    padding: 10px;
  }

  .nurturer-platform .platform-nav-badge {
    position: absolute;
    top: 4px;
    right: 4px;
    margin: 0;
    min-width: 16px;
    padding: 0 4px;
    font-size: 10px;
  }

  .nurturer-platform .platform-search {
    display: none;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
